module.exports = __webpack_public_path__ + "static/media/raceGameConcepts_02.bfde0d82.jpg";